import { FormattedMessage as FM, useIntl } from "react-intl";

function ListError({ error }) {
  const intl = useIntl();
  if (!error) return null;
  const values = error.field
    ? { field: intl.formatMessage({ id: error.field }) }
    : undefined;
  return (
    <p role="alert" className="text-sm text-red-700">
      <FM id={error.id} values={values} />
      {error.detail && <span className="block text-xs">{error.detail}</span>}
    </p>
  );
}

export default ListError;
